import { y } from '@circlefin/form'
import { L3OnboardingFields } from '@features/l3-onboarding/fields'
import { LocalsForms } from '@features/locales/forms'

export const vatNumberSchema = y.string().max(20, { key: 'max', max: 20 })

export const billingProfileFormSchemaFields = {
  billingContact: y.object({
    email: y.string().email().max(70, { key: 'max', max: 70 }).required(),
  }),
  billingAddress: y.object({
    line1: y
      .string()
      .noRestrictedCharacters()
      .max(100, { key: 'max', max: 100 })
      .required(),
    line2: y
      .string()
      .noRestrictedCharacters()
      .max(100, { key: 'max', max: 100 }),
    city: y
      .string()
      .noRestrictedCharacters()
      .max(50, { key: 'max', max: 50 })
      .required(),
    district: L3OnboardingFields.Input.Address.stateSchema('country').max(50, {
      key: 'max',
      max: 50,
    }),
    postalCode: L3OnboardingFields.Input.Address.postCodeSchema('country').max(
      20,
      { key: 'max', max: 20 },
    ),
    country: LocalsForms.Dropdown.countrySchema,
  }),
  phoneNumber: L3OnboardingFields.Utils.phoneNumberSchema
    .max(50, { key: 'max', max: 50 })
    .required(),
  vatNumber: vatNumberSchema,
}

export const billingProfileFormSchema = y.object(billingProfileFormSchemaFields)

export type BillingProfileFormValues = y.InferType<
  typeof billingProfileFormSchema
>
